import { useRef, useState } from "react";
import { buildResultEmailPayload, RESULT_EMAIL_ENDPOINT } from "./resultEmailPayload";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const MESSAGES = {
  invalidEmail: "Enter a valid email address.",
  server: "We couldn't email your result. Please try again.",
};

export const useResultEmail = (profile) => {
  const [state, setState] = useState("default");
  const [error, setError] = useState(null);
  const pending = useRef(false);
  const startedAt = useRef(Date.now());

  const reset = () => {
    setState("default");
    setError(null);
    startedAt.current = Date.now();
  };

  const submit = async ({ email, website }) => {
    if (pending.current || state === "sending") return { ok: false };
    if (!email || !EMAIL_RE.test(email.trim())) {
      setState("error");
      setError(MESSAGES.invalidEmail);
      return { ok: false };
    }

    pending.current = true;
    setState("sending");
    setError(null);

    try {
      const response = await fetch(RESULT_EMAIL_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(
          buildResultEmailPayload({
            profile,
            email,
            website,
            startedAt: startedAt.current,
          })
        ),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      let data = null;
      try {
        data = await response.json();
      } catch {
        // An empty 2xx response is acceptable.
      }
      if (data && data.ok === false) throw new Error("Provider error");

      setState("success");
      return { ok: true };
    } catch {
      setState("error");
      setError(MESSAGES.server);
      return { ok: false };
    } finally {
      pending.current = false;
    }
  };

  return { state, error, submit, reset };
};
